(() => {
  function init(root) {
    if (root.dataset.geoReady) return;
    root.dataset.geoReady = 'true';
    const track = root.querySelector('.dm-pawcaddie-wall__track');
    const cards = Array.from(track.children);
    const toggle = root.querySelector('[data-geo-toggle]');
    const count = root.querySelector('.dm-pawcaddie-wall__count');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = motion.matches;
    let visible = false;
    let touching = false;
    let resumeAt = 0;
    track.style.scrollSnapType = 'none';
    root.dataset.geoMotion = 'continuous';
    let frame = 0;
    let lastMove = Date.now();
    function stepSize() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    function current() { return Math.max(0, Math.round(track.scrollLeft / stepSize())); }
    function update() {
      const first = current();
      const shown = Math.max(1, Math.round((track.clientWidth + 18) / stepSize()));
      count.textContent = (first + 1) + (shown > 1 ? '–' + Math.min(first + shown, cards.length) : '') + ' / ' + cards.length;
    }
    function setPaused(value) {
      paused = value;
      toggle.textContent = value ? root.dataset.playLabel : root.dataset.pauseLabel;
      root.dataset.geoPlaying = String(!value);
      resumeAt = 0;
      lastMove = Date.now();
    }
    function move(direction) {
      const step = stepSize();
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      let left = track.scrollLeft + direction * step;
      if (direction > 0 && track.scrollLeft >= max - 3) left = 0;
      else if (direction < 0 && track.scrollLeft < 3) left = max;
      track.scrollTo({left: Math.max(0, Math.min(max, left)), behavior: motion.matches ? 'auto' : 'smooth'});
      lastMove = Date.now();
    }
    root.querySelector('[data-geo-prev]').addEventListener('click', () => { resumeAt = Date.now() + 5000; move(-1); });
    root.querySelector('[data-geo-next]').addEventListener('click', () => { resumeAt = Date.now() + 5000; move(1); });
    toggle.addEventListener('click', () => setPaused(!paused));
    track.addEventListener('pointerdown', () => { touching = true; }, {passive:true});
    window.addEventListener('pointerup', () => { if (touching) { touching = false; resumeAt = Date.now() + 5000; } }, {passive:true});
    window.addEventListener('pointercancel', () => { touching = false; resumeAt = Date.now() + 5000; }, {passive:true});
    track.addEventListener('wheel', event => { if (Math.abs(event.deltaX) > 0) resumeAt = Date.now() + 5000; }, {passive:true});
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); setPaused(true); move(event.key === 'ArrowRight' ? 1 : -1); }
    });
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true});
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; lastMove = Date.now(); }, {threshold:0.15});
    observer.observe(track);
    const resize = new ResizeObserver(update); resize.observe(track);
    motion.addEventListener('change', () => { if (motion.matches) setPaused(true); });
    root.querySelector('.dm-pawcaddie-wall__controls').hidden = false;
    setPaused(paused); update();
    let previous = performance.now();
    let position = track.scrollLeft;
    let running = false;
    function tick(now) {
      if (!root.isConnected) { observer.disconnect(); resize.disconnect(); return; }
      const delta = Math.min(50, now - previous);
      previous = now;
      const keyboardFocus = track.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      const active = !paused && visible && !document.hidden && !touching && !keyboardFocus && Date.now() >= resumeAt;
      if (active) {
        if (!running) position = track.scrollLeft;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        position += delta * 0.045;
        if (position >= max) position = 0;
        track.scrollLeft = position;
      }
      running = active;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  document.querySelectorAll('[data-dm-pawcaddie-wall="56-20261001"]').forEach(init);
})();
